import { motion, useAnimationControls } from 'framer-motion';

import Image from 'next/image';
import { useEffect } from 'react';

interface InfiniteImageTickerProps {
  images: { src: string; alt: string }[];
}

const InfiniteImageTicker = ({ images }: InfiniteImageTickerProps) => {
  const controls = useAnimationControls();
  const duration = 90;

  useEffect(() => {
    const animate = async () => {
      while (true) {
        await controls.start({
          x: '-50%',
          transition: {
            duration,
            ease: 'linear',
            repeat: 0,
          },
        });
        await controls.set({ x: '0%' });
      }
    };

    animate();
    return () => controls.stop();
  }, [controls]);

  const extendedImageUrls = [...images, ...images, ...images];

  return (
    <div className="relative overflow-hidden w-full max-w-[95vw] overflow-x-hidden">
      <motion.div className="flex whitespace-nowrap w-max" animate={controls}>
        {[0, 1].map((setIndex) => (
          <div key={setIndex} className="flex">
            {extendedImageUrls.map((url, index) => (
              <div
                key={`${setIndex}-${index}`}
                className="w-[150px] h-[250px] sm:h-[300px] md:h-[350px] lg:h-[400px] sm:w-[200px] md:w-[250px] lg:w-[300px] relative flex-shrink-0"
              >
                <Image
                  src={url.src}
                  alt={url.alt}
                  fill
                  className="object-cover"
                />
              </div>
            ))}
          </div>
        ))}
      </motion.div>
    </div>
  );
};

export default InfiniteImageTicker;
